import { apiGet, apiPost } from './client'
import type {
  GameActionRequest,
  ActionResponse,
  DonationRequest,
  DonationAcceptRequest,
  DonationRejectRequest,
  ColonyCollapseOfferRequest,
  ColonyCollapseResolveRequest,
  WinterTradeRequest,
  WoollyFurChoiceRequest,
} from '../types/api'
import type { AvailableActionsResponse } from '../types/game'

export function postAction(
  roomId: string,
  action: GameActionRequest
): Promise<ActionResponse> {
  return apiPost<ActionResponse>(`/rooms/${roomId}/actions`, action)
}

export function getAvailableActions(
  roomId: string,
  memberId: string
): Promise<AvailableActionsResponse> {
  return apiGet<AvailableActionsResponse>(`/rooms/${roomId}/moves/${memberId}`)
}

export function getPhaseContract(roomId: string): Promise<unknown> {
  return apiGet(`/rooms/${roomId}/phase`)
}

export function sendDonation(
  roomId: string,
  request: DonationRequest
): Promise<unknown> {
  return apiPost(`/rooms/${roomId}/donations`, request)
}

export function acceptDonation(
  roomId: string,
  request: DonationAcceptRequest
): Promise<unknown> {
  return apiPost(`/rooms/${roomId}/donations/accept`, request)
}

export function rejectDonation(
  roomId: string,
  request: DonationRejectRequest
): Promise<unknown> {
  return apiPost(`/rooms/${roomId}/donations/reject`, request)
}

export function resolveWoollyFurChoice(
  roomId: string,
  request: WoollyFurChoiceRequest
): Promise<unknown> {
  return apiPost(`/rooms/${roomId}/woolly-fur/resolve`, request)
}

export function sendWinterTrade(
  roomId: string,
  request: WinterTradeRequest
): Promise<unknown> {
  return apiPost(`/rooms/${roomId}/winter-trade`, request)
}

export function sendColonyCollapseOffer(
  roomId: string,
  request: ColonyCollapseOfferRequest
): Promise<unknown> {
  return apiPost(`/rooms/${roomId}/colony-collapse/offers`, request)
}

export function resolveColonyCollapse(
  roomId: string,
  request: ColonyCollapseResolveRequest
): Promise<unknown> {
  return apiPost(`/rooms/${roomId}/colony-collapse/resolve`, request)
}

export function triggerBotTurns(roomId: string): Promise<unknown> {
  return apiPost(`/rooms/${roomId}/bot-turns`)
}

export function replaceStaleMemberWithBot(
  roomId: string,
  color: string,
  hostId: string
): Promise<unknown> {
  return apiPost(`/rooms/${roomId}/stale-members/${color}/replace-with-bot`, {
    host_id: hostId,
  })
}
